import { element ,IRootScopeService,translate,IWindowService,IHttpService,auto, ILocationService,IQProvider,ui} from 'angular';
import { Transition } from "@uirouter/core";
import { Constant } from "./model/common/constant";
import { Exception } from "./model/common/exception";


import "angular-translate";
import "messageformat";
import "angular-translate-interpolation-messageformat";

import { IWindowOption, WindowService } from "./shared/services/common/window/window.service";

export module Path {

    export class Provider {

        public static ApplicationPath: string;
        public static AssetsPath: string;
        public static RequestToken: string;
        public static ApplicationVersion: string;


        static SetValue(appPath: string, assetPath: string, token: string, appVersion: string) {
            Provider.ApplicationPath = appPath;
            Provider.AssetsPath = assetPath;
            Provider.RequestToken = token;
            Provider.ApplicationVersion = appVersion;
        }
    }

    export const APIUrl = {

        /*DASHBOARD*/
        GetLoggedUserInfoUrl: () => { return Provider.ApplicationPath + "UserManagement/Dashboard/GetLoggedUserInfo" },
        GetAllCompaniesUrl: () => { return Provider.ApplicationPath + "UserManagement/Dashboard/GetAllCompanies" },
        //UpdateSelectedCompanyCEIDInSessionForHonweyllPersonaUrl: () => { return Provider.ApplicationPath + "UserManagement/Dashboard/UpdateSelectedCompanyCEIDInSessionForHonweyllPersona" },

        /*USER PROFILE*/
        UserProfileDetailsUrl: () => { return Provider.ApplicationPath + "UserManagement/UserAccount/GetCurrentUserProfileDetails" },
        UpdateUserProfileUrl: () => { return Provider.ApplicationPath + "UserManagement/UserAccount/UpdateUserProfile" },
        GetAllSecurityQuestionsUrl: () => { return Provider.ApplicationPath + "UserManagement/UserAccount/GetUserSelectedSecretQuestions" },
        SaveUserPasswordUrl: () => { return Provider.ApplicationPath + "UserManagement/UserAccount/SaveUserPassword" },
        SaveUserSecretQuestionAnswerUrl: () => { return Provider.ApplicationPath + "UserManagement/UserAccount/SaveSecurityQuestionAnswer" },
        getDefaultPagesUrl: () => { return Provider.ApplicationPath + "UserManagement/UserAccount/GetDefaultLandingPages" },
        getSupportedCultures: () => { return Provider.ApplicationPath + "UserManagement/UserAccount/GetSupportedCultures" },
        getSupportedCountry: () => { return Provider.ApplicationPath + "UserManagement/UserAccount/GetSupportedCountry" },

        getPreferredLanguageFeature: () => { return Provider.ApplicationPath + "UserManagement/UserAccount/GetPreferredLanguageFeature" },
        logOff: () => { return Provider.ApplicationPath + "Login/UMLogin/LogOff" },
        getGoogleTranslationFeature: () => { return Provider.ApplicationPath + "UserManagement/UserAccount/GetGoogleTranslationFeature" },

        logUserPIDataUrl: () => { return Provider.ApplicationPath + "UserManagement/UserAccount/logUserPIData" },

        //Login
        VerifyUserIdenityUrl: () => { return Provider.ApplicationPath + "Login/UMLogin/ValidateUserIdentity" },
        ResetExpiredPasswordUrl: () => { return Provider.ApplicationPath + "Login/UMLogin/ResetExpiredPassword" },
        ResetExpiredPasswordWithSecretQuestionUrl: () => { return Provider.ApplicationPath + "Login/UMLogin/ResetExpiredPasswordWithSecretQuestion" },
        
        /*ROLE*/
        FeatureSetListUrl: () => { return Provider.ApplicationPath + "UserManagement/Role/GetAvailableFeatureSet" },
        GetAllRolesUrl: () => { return Provider.ApplicationPath + "UserManagement/Role/GetAll" },
        GetAllRolesWithSearchCriteriaUrl: () => { return Provider.ApplicationPath + "UserManagement/Role/GetAllRolesWithSearchCriteria" },
        GetRoleDetails: () => { return Provider.ApplicationPath + "UserManagement/Role/Get" },
        SaveRoleUrl: (): string => { return Provider.ApplicationPath + "UserManagement/Role/InsertUpdateRole" },
        GetDeleteRoleSummaryListUrl: (): string => { return Provider.ApplicationPath + "UserManagement/Role/GetDeleteRoleSummaryList" },
        DeleteRoleUrl: (): string => { return Provider.ApplicationPath + "UserManagement/Role/DeleteRole" },

        /*GROUP*/
        SaveGroupUrl: (): string => { return Provider.ApplicationPath + "UserManagement/Group/AddEditGroup" },
        GetAllGroupsWithSearchCriteriaUrl: () => { return Provider.ApplicationPath + "UserManagement/Group/GetAllGroupsForCompanyWithSearchCriteria" },
        GetAllGroupsUrl: () => { return Provider.ApplicationPath + "UserManagement/Group/GetAllGroupsForCompany" },
        GetGroupDetails: () => { return Provider.ApplicationPath + "UserManagement/Group/Get" },
        GetAllCityCSUrl: () => { return Provider.ApplicationPath + "UserManagement/Group/GetAllCityCSForCompany" },
        DeleteGroupUrl: () => { return Provider.ApplicationPath + "UserManagement/Group/DeleteGroup" },
        GetAllUsersForGroupUrl: () => { return Provider.ApplicationPath + "UserManagement/Group/GetAllUsersForAGroup" },
        GetAllTimeZonesUrl: () => { return Provider.ApplicationPath + "UserManagement/Group/GetAllTimezones" },
        /*USER*/
        GetAllUserListUrl: () => { return Provider.ApplicationPath + "UserManagement/User/GetAllUsersForACompany" },
        GetLocale: () => { return Provider.ApplicationPath + "Areas/UserManagement/dist/locale/locale-" },

        SaveUserUrl: () => { return Provider.ApplicationPath + "UserManagement/User/InsertUpdateUser" },
        GetUserDetails: () => { return Provider.ApplicationPath + "UserManagement/User/Get" },
        CheckIfUserExistsInSameCompany: () => { return Provider.ApplicationPath + "UserManagement/User/CheckIfUserExistsInSameCompany" },
        CheckIfUserExists: () => { return Provider.ApplicationPath + "UserManagement/User/CheckIfUserExists" },
        ResendActivationMail: () => { return Provider.ApplicationPath + "UserManagement/User/ResendActivationLink" },
        EnableDisableUser: () => { return Provider.ApplicationPath + "UserManagement/User/EnableDisableUser" },
        UnlockUser: () => { return Provider.ApplicationPath + "UserManagement/User/ResetPasswordEmail" },
        GetUserImpersonationDetailsUrl: () => { return Provider.ApplicationPath + "UserManagement/User/GetUserImpersonationDetails" },
        GenerateUserImpersonationLinkUrl: () => { return Provider.ApplicationPath + "UserManagement/User/GenerateUserImpersonationLink" },
        CheckIfGroupIsAtLimit: () =>{ return Provider.ApplicationPath + "UserManagement/User/CheckForAmountOfUsersInGroup"},


        /*USERREGISTRATION*/
        CheckLoginNameAvailability: () => { return Provider.ApplicationPath + "UserManagement/UserRegistration/CheckLoginAvailablity" },
        CompleteUserSetup: () => { return Provider.ApplicationPath + "UserManagement/UserRegistration/CompleteUserSetup" },
        ActivateUserLoginGroupStatus: () => { return Provider.ApplicationPath + "UserManagement/UserRegistration/ActivateUserLoginGroupStatus" },
        ResetPassword: () => { return Provider.ApplicationPath + "UserManagement/UserRegistration/CompleteResetPassword" },
        UpdateUserPassword: () => { return Provider.ApplicationPath + "UserManagement/UserRegistration/UpdateUserPassword" },
        ForgotPassword: () => { return Provider.ApplicationPath + "UserManagement/UserRegistration/ForgotPassword" },
        ForgotUsername: () => { return Provider.ApplicationPath + "UserManagement/UserRegistration/ForgotUsername" },
        ValidateSecurityQuestions: () => { return Provider.ApplicationPath + "UserManagement/UserRegistration/ValidateSecurityQuestions" },

        /*NOTIFICATION MANAGEMENT*/
        GetLoggedInRegion: () => { return Provider.ApplicationPath + "ManageNotifications/Notifications/GetLoggedInRegion" },
        GetAllNotificationListUrl: () => { return Provider.ApplicationPath + "ManageNotifications/Notifications/GetAllNotifications" },
        GetNotificationDetails: () => { return Provider.ApplicationPath + "ManageNotifications/Notifications/GetNotificationById" },
        GetNotification: () => { return Provider.ApplicationPath + "ManageNotifications/Notifications/GetNotification" },
        SaveNotificationUrl: () => { return Provider.ApplicationPath + "ManageNotifications/Notifications/SaveNotifications" },
        DeleteNotificationDetails: () => { return Provider.ApplicationPath + "ManageNotifications/Notifications/DeleteNotification" },
        GetConflictedAlerts: () => { return Provider.ApplicationPath + "ManageNotifications/Notifications/GetConflictedAlerts" },
        IsFeatureControlled: () => { return Provider.ApplicationPath + "Accounts/AccountManagement/IsFeatureControlled" },
        GetWhatsnewUpdatesAlerts: () => { return Provider.ApplicationPath + "ManageNotifications/Notifications/GetAllWhatsnewUpdatesAlertList" },
        GetAllSupportAndResources: () => { return Provider.ApplicationPath + "ManageNotifications/Notifications/GetAllSupportAndResources" },
        SaveSupportAndResources: () => { return Provider.ApplicationPath + "ManageNotifications/Notifications/SaveSupportAndResources" },
        GetWhiteListedURLs: () => { return Provider.ApplicationPath + "ManageNotifications/Notifications/GetWhiteListedURLs" }

    }
}

export module AppConfig {
    export const UserManagementModuleName: string = 'UserManagementApp';
    export const UserSetUpModuleName: string = 'UserSetUpApp';
    export const UserAccountModuleName: string = 'UserAccountApp';
    export const ForgotLoginModuleName: string = 'ForgotLoginApp';
    export const NotificationManagementModuleName: string = 'NotificationManagementApp';
    export const NotificationManagementHistoryModuleName: string = 'NotificationManagementHistoryApp';
}

export let AppRunBlock = ['$rootScope','$location', "$translate", "$window", "$http", "$transitions",
    function (
        $rootScope: IRootScopeService,
        $location: ILocationService,
        $translate: translate.ITranslateService,
        $window: IWindowService,
        $http: IHttpService,
        $transitions: Transition
    ) {

        $transitions.onSuccess({}, function (trans) {

            $rootScope.$broadcast(Constant.Event.StateChangedSucess, trans.router.stateService);
            if (trans.to().data && trans.to().data.name) {
                $window.logLocalytics(trans.to().data.name, {});
            }
        });

        element($window).on('resize', function () {
            $rootScope.$broadcast(Constant.Event.WindowResized);
        });

        $http.defaults.headers = {

            common: {
                'Authorization': 'Basic Authorization',
                '__RequestVerificationToken': Path.Provider.RequestToken,
                'X-Requested-With': 'XMLHttpRequest',
                "Content-Type": "application/json"
            }
        }
    }
]
function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
export let AppConfigBlock = [
    '$translateProvider',
    '$urlRouterProvider',
    '$stateProvider',
     '$provide',
      '$qProvider',
    (
        $translateProvider: translate.ITranslateProvider,
        $urlRouterProvider: ui.IUrlRouterProvider,
        $stateProvider: ui.IStateProvider,
        $provide: auto.IProvideService,
        $qProvider: IQProvider) => {

        ////https://angular-translate.github.io/docs/#/guide/12_asynchronous-loading
        //"https://localhost:8080/ValueNetWeb/Areas/UserManagement/dist/"
        $translateProvider.useStaticFilesLoader({
            'prefix': Path.Provider.AssetsPath + 'locale/locale-',
            'suffix': '.json?v=' + Path.Provider.ApplicationVersion
        });
        $translateProvider.useSanitizeValueStrategy('escape');
       var cookies_lang = getCookie("CultureCode") || getCookie("i18next");       
        if (cookies_lang.length === 0) {
            cookies_lang = "en-US";
        }
        else if (!["de-DE", "es-ES", "fi-FI", "fr-FR", "it-IT", "nl-NL", "nn-NO", "pt-PT", "sv-SE"].includes(cookies_lang)){
            cookies_lang = "en-US";
        }
        $translateProvider.preferredLanguage(cookies_lang);
        $translateProvider.forceAsyncReload(true);
        $translateProvider.useMessageFormatInterpolation();
        //Global Exception Handler
        $provide.decorator("$exceptionHandler", ["$delegate", "$injector", ($delegate: ng.IExceptionHandlerService, $injector: ng.auto.IInjectorService) => {
            return function (exception: Exception, cause) {
                $delegate(exception, cause);
                if (exception.showErrorWindow) {
                    var window = $injector.get("WindowService") as WindowService;
                    window.showErrorWindow({ TextContent: exception.message, ParentEl: element(document.body) } as IWindowOption);
                }
            }
        }]);

        //$qProvider.errorOnUnhandledRejections(false);
    }];

//Allowed url's in notification editor
export const AllowedDomains = ['honeywell.com', 'youtube.com'];